import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const deleteQuestionAsset = (formId: string, sectionId: string, questionId: string): ReturnType => {
    return Request.delete(
        `/data/forms/${formId}/sections/${sectionId}/questions/${questionId}/asset`,
    );
};

export default deleteQuestionAsset;
